import { GoabButton, GoabModal, GoabText } from '@abgov/angular-components';
import { Component, input, output } from '@angular/core';

/**
 * Generic yes/no confirmation dialog wrapping `<goab-modal>`. Callers own all
 * copy and the decision of what "confirm"/"cancel" mean; this only renders
 * the shell and re-emits the two outcomes plus the modal's own close event.
 */
@Component({
  selector: 'common-confirm-modal',
  standalone: true,
  imports: [GoabModal, GoabButton, GoabText],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
})
export class ConfirmModalComponent {
  open = input.required<boolean>();
  heading = input.required<string>();
  message = input.required<string>();
  confirmLabel = input('Confirm');
  cancelLabel = input('Cancel');
  testIdPrefix = input('confirm-modal');

  confirmed = output<void>();
  cancelled = output<void>();
}
